import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import { Customer } from "utils/interfaces";
import CustomerDetailDeadlines from "./Deadlines/CustomerDetailDeadlines";
import CustomerDetailCommunications from "./Communications/CustomerDetailCommunications";

interface CustomerDetailOtherInfoProps {
    customer: Customer;
}

export default function CustomerDetailOtherInfo({ customer }: CustomerDetailOtherInfoProps) {
    const shadow = useColorModeValue(
        '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
        '14px 17px 40px 4px rgba(112, 144, 176, 0.06)'
    );

    return (
        <Box
            backgroundColor="white"
            borderRadius="20px"
            boxShadow={shadow}
            mr={{ base: 0, md: 3 }}
            width="100%"
        >
            <Tabs variant="enclosed">
                <TabList p="15px">
                    <Tab>Scadenze</Tab>
                    <Tab>Comunicazioni</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        <CustomerDetailDeadlines customer={customer} /> {/* Pannello per le scadenze */}
                    </TabPanel>
                    <TabPanel>
                        <CustomerDetailCommunications customer={customer} /> {/* Pannello per le comunicazioni */}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}